import Icon from '../components/Icon';

const RotateLeft = Icon(
  'rotate-left',
  <>
    <path d="M15.447 3.684A9 9 0 0 0 5.64 5.638L3.73 7.54V4.847a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 .75.75h4.5a.75.75 0 1 0 0-1.5H4.796l1.903-1.898a7.5 7.5 0 1 1 0 10.602.75.75 0 1 0-1.06 1.06 9 9 0 1 0 9.808-14.677" />
  </>
);

export default RotateLeft;
